module.exports = __webpack_public_path__ + "static/media/39.8e3c71a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/39.jpg
// module id = 600
// module chunks = 0